import { Map } from 'immutable';

import { LOCATION_OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { EMPTY } from '../../../../constants';

export function itemLocation({ channel, preview }) {
  function reduceLocationPreview(result, value, type) {
    result.push(Map({ type: LOCATION_OPERATIONS[channel][type], value }));
    return result;
  }

  return { payload: preview.get(ATTRIBUTE.SHIPPING, EMPTY.MAP).delete('operation').reduce(reduceLocationPreview, []) };
}
